var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:((_vm.alert.time >= 0)? 'position:fixed; padding: 1px; z-index: 900; min-width: 80%' : '')},[_c('v-alert',{attrs:{"value":_vm.alert.ativo,"color":_vm.alert.msg_type,"transition":"scale-transition"}},[_vm._v("\n    "+_vm._s(_vm.alert.msg)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }